import { render } from "./CriteriaList.vue?vue&type=template&id=29694548"
import script from "./CriteriaList.vue?vue&type=script&lang=js"
export * from "./CriteriaList.vue?vue&type=script&lang=js"

import "./CriteriaList.vue?vue&type=style&index=0&id=29694548&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__